import * as amplify from "./amplify.ts";
import * as FwDatas from "../FwDatas.ts";
import { localGet, localSet } from "../lib/Storage.ts";
import { BaseCache } from "../lib/SyncCache.ts";
import * as Html from "../util/Html.ts";
import Icons from "../svg/Icons.ts";
import * as modal from "./modal.ts";
import { registerDragStart } from "../lib/FileUtils.ts";

type MemberWithOrder = {sortingIndex:number,activated:boolean,member:any}
type MemberOrderMap = {[accountId:string]:{sortingIndex:number,activated:boolean}}
function getOrder() : MemberOrderMap{
  var order = JSON.parse(localGet('family.order'+FwDatas.getFamily().metaId)||"{}")
  var result = {}
  FwDatas.getFamily().members.forEach((member,idx)=>{
    return result[member.accountId] = order[member.accountId]||{sortingIndex:idx*10000,activated:true}
  })
  return result;
}
function saveOrder(order :MemberOrderMap){
  localSet('family.order'+FwDatas.getFamily().metaId,JSON.stringify(order))
}
export const MemberOrder = new BaseCache<MemberWithOrder[]>(()=>{
  return new Promise((resolve,reject)=>{
    var enrichedMember = Object.entries(getOrder()).map(([key,value])=>{
      return {
        activated:value.activated,
        sortingIndex:value.sortingIndex,
        member:FwDatas.getProfile(key)
      }
    });
    enrichedMember.sort((a,b)=>a.sortingIndex-b.sortingIndex)
    resolve(enrichedMember)
  })
})
export function clearMemberOrderFilter(){
  var order = getOrder()
  Object.entries(order).forEach(([key,value])=>{
    value.activated = true;
  })
  saveOrder(order);
  MemberOrder.invalidate()
}
export function memberToggleFilter(activated:boolean, ...memberIds:(string|number)[]){
  var
    order = getOrder(),
    change = false;
  memberIds.forEach(memberId=>{
    if(order[memberId]!==undefined){
      change = order[memberId].activated !== activated
      order[memberId].activated = activated
    }
  })
  if(change){
    saveOrder(order)
    MemberOrder.invalidate()
    amplify.publish('familyMemberChange')
  }
}
Html.registerDom({
  async memberordersettings(){
    var
      TPL = await import("../calendar/member_order.mustache"),
      theModal = modal.openDomModal(TPL,{members:await MemberOrder.refresh()}),
      theButton = theModal.querySelector('button');
    if(theButton){
      theButton.addEventListener('click',()=>{
        var
          order = {},
          oneActivated = false;
        theModal.querySelectorAll('[data-fw-meta-id]').forEach((node,idx)=>{
          order[node.getAttribute('data-fw-meta-id')] = {
            sortingIndex:idx*1000,
            activated:node.getAttribute('activated')==='true'
          }
          oneActivated = oneActivated || node.getAttribute('activated')==='true'
        })
        if(oneActivated){
          saveOrder(order);
          modal.closeDomModal(theModal);
          amplify.publish('familyMemberChange')
        }else{
          modal.alert('calendarmember.errormustcheck')
        }
      })
    }
  },

  memberordertoggle(){
    var
      node = Html.getDomMetaIdNode(this.get(0)),
      activated = node.getAttribute('activated')!=='true';
    node.setAttribute('activated',""+activated)
    this.get(0).style.color = activated?'var(--fwPrimary)':'var(--fwOutline)'
    this.html(activated?Icons.ic_checked.toString():Icons.ic_checkbox.toString())
  },
  memberorderclear(){
    clearMemberOrderFilter()
    modal.closeDomModal();
    amplify.publish('familyMemberChange')
    return false
  },
})

registerDragStart(".reorderable>*",async function(ev,dropPromiseBuilder){
  const movingNode = this;
  const potentialDrop = Array.from(document.querySelectorAll<HTMLElement>('.reorderable > *'));
  const dropEvent = await dropPromiseBuilder(this, potentialDrop);
  const dropNode = dropEvent.target as HTMLElement;

  // Récupère la position et la hauteur du dropNode
  const rect = dropNode.getBoundingClientRect();
  const dropCenterY = rect.top + rect.height / 2;

  let nodeBefore = null;

  if (dropCenterY > dropEvent.clientY) {
    nodeBefore = dropNode.previousElementSibling;
    dropNode.parentNode.insertBefore(movingNode, dropNode);
  } else {
    nodeBefore = dropNode;
    dropNode.parentNode.insertBefore(movingNode, dropNode.nextElementSibling);
  }

})
